// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card_Card__1oeUq","CardHeader":"Card_CardHeader__bX_vl","CardBody":"Card_CardBody__3kEuV","CardFooter":"Card_CardFooter__3kXhC"};